export default "__VITE_ASSET__DK8W6wSE__"